import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from './types/CodeableConcept';
import Quantity from './types/Quantity';
import BN_MedicationPresetTaperStep from './BN_MedicationPresetTaperStep';

/**
 * One medication order in a preset. Each field is named after the MedicationRequest field it
 * lands on when the preset is applied, which is a copy by value: nothing on the patient's
 * medication points back here, so editing a preset never changes one already added from it.
 */
export default class BN_MedicationPresetItem extends BackboneElement {
    static __className = 'BN_MedicationPresetItem';

    __objectStructure = {
        medication: CodeableConcept, // coded RxNorm only
        administrationType: String, // scheduled | prn | taper
        dose: Quantity,
        route: CodeableConcept,
        frequency: Number,
        period: Number,
        periodUnit: String, // d | wk
        maxPerDay: Number,
        minimumInterval: Quantity, // FHIR Duration; Quantity is structurally identical
        patientInstruction: String,
        reasonCode: [CodeableConcept],
        includeInTreatmentPlan: Boolean,
        afterFinal: String, // stop | continue
        taperNotes: String,
        taperStep: [BN_MedicationPresetTaperStep],
    };

    constructor(constructJson, className = 'BN_MedicationPresetItem') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
